import React from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import KeywordPanel from './components/KeywordPanel';
import CategoryPanel from './components/CategoryPanel';
import LocationPanel from './components/LocationPanel';
import PriceRangePanel from './components/PriceRangePanel';
import RentalPeriodPanel from './components/RentalPeriodPanel';

const FilterSection = styled('aside')`
  flex-basis: 25%;
`;

const Heading = styled(Typography)`
  width: 100%;
  padding: 15px 20px;
  font-size: 12px !important;
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 5px 5px 0 0;
  color: ${({ theme }) => theme.colors.plainWhite};
`;
type Filters = {
  isWantedSearch: boolean;
};
const Filters = ({ isWantedSearch }: Filters) => {
  return (
    <FilterSection>
      <Heading variant="overline" display="block">
        Narrow your Search
      </Heading>
      <KeywordPanel isWantedSearch={isWantedSearch} />
      <CategoryPanel isWantedSearch={isWantedSearch} />
      <LocationPanel isWantedSearch={isWantedSearch} />
      <PriceRangePanel isWantedSearch={isWantedSearch} />
      <RentalPeriodPanel isWantedSearch={isWantedSearch} />
    </FilterSection>
  );
};
export default Filters;
